module.exports = __webpack_public_path__ + "static/verde-f30264601e5a385ef85810ecc0470cf5.png";